import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { deleteLanguageRule } from '../api'
import { languageRulesKeys } from '../queryKeys'

const useDeleteLanguageRuleMutation = ({
  ruleId,
  onSuccess,
}: {
  ruleId: string
  onSuccess?: () => void
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => deleteLanguageRule({ ruleId, accountId }),
    onSuccess: async () => {
      onSuccess?.()
      successToast(`Language rule successfully deleted`)
      queryClient.invalidateQueries({
        queryKey: languageRulesKeys.list(accountId),
      })
    },
    onError: () => {
      errorToast('Language rule could not be deleted')
    },
  })
}

export default useDeleteLanguageRuleMutation
